import styled from "styled-components";

import { NoCoverageNotificationStyledProps as Props } from "./NoCoverageNotification.types";
import Notification from "components/global/notifications/Notification/Notification";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const NoCoverageNotificationStyled = styled(Notification)<Props>`
  display: ${props => (props.opened ? "block" : "none")};
  border-left: 1rem solid var(--palette-primary);
  padding-top: 1.2rem;

  @media (max-width: ${mobile}px) {
    padding: 1rem !important;
    border-left: 0.6rem solid var(--palette-primary);
    display: ${props => (props.opened ? "grid" : "none")};
    grid-template-columns: auto 10.8rem;
    align-items: center;
  }

  .NoCoverageNotification {
    &__title {
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 2.8rem;
      padding-top: 1.2rem;
      color: var(--palette-white);

      @media (max-width: ${mobile}px) {
        padding-top: 0;
        font-size: 1.4rem;
        line-height: 2.4rem;
      }
    }

    &__button,
    &__description {
      font-size: 1.4rem;
      line-height: 2.4rem;
    }

    &__icon {
      width: 4.8rem;
      height: 4.8rem;
      background-color: var(--palette-white);
      border-radius: 90%;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: ${mobile}px) {
        display: none;
      }

      svg {
        path {
          fill: var(--palette-black);
        }
      }
    }

    &__description {
      padding-bottom: 1.6rem;
      color: var(--palette-gray-s0-l61);

      @media (max-width: ${mobile}px) {
        padding-bottom: 0.8rem;
        line-height: 1.6rem;
      }
    }

    &__button {
      font-weight: 600;
      padding: 0.8rem 2rem;
      max-width: 20.8rem;
      background-color: transparent;
      border-color: var(--palette-white) !important;
      color: var(--palette-white) !important;
      border-radius: 0.4rem !important;

      &--desktop {
        @media (max-width: ${mobile}px) {
          display: none !important;
        }
      }

      &--mobile {
        grid-column: 2/3;
        grid-row: 1/3;
        max-width: 8rem;
        height: 4.8rem;
        padding: 0.8rem !important;
        display: none !important;
        font-size: 1.4rem !important;

        @media (max-width: ${mobile}px) {
          display: block !important;
        }
      }

      &:hover {
        background-color: transparent !important;
      }
    }
  }
`;

export default NoCoverageNotificationStyled;
